export default "__VITE_ASSET__CqRsN0Gp__"